import { Head } from "vite-react-ssg";

interface StructuredDataProps {
  type?: "home" | "organization" | "localBusiness";
}

/**
 * @deprecated — Global structured data is now handled by GlobalStructuredData in the Layout.
 * This component is kept as a no-op to avoid breaking existing imports across ~59 pages.
 */
export const StructuredData = (_props: StructuredDataProps) => {
  return null;
};
